import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import { theme } from '../theme';

const Switcher = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  @media (max-width: 768px) {
    gap: 0.75rem;
    width: 100%;
    justify-content: center;
  }
`;

const Button = styled.button<{ active: boolean }>`
  background: ${({ active }) => (active ? theme.colors.green : theme.colors.black)};
  color: ${({ active }) => (active ? theme.colors.black : theme.colors.white)};
  border: 1px solid ${({ active }) => (active ? theme.colors.green : 'rgba(255, 255, 255, 0.3)')};
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s ease;
  min-height: 44px;
  min-width: 60px;
  
  &:hover {
    background: ${theme.colors.green};
    color: ${theme.colors.black};
    border-color: ${theme.colors.green};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.75rem 1.5rem;
    font-size: 1.1rem;
    min-width: 80px;
    border-radius: 8px;
  }
`;

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <Switcher>
      <Button active={language === 'cz'} onClick={() => setLanguage('cz')} data-active={language === 'cz'}>CZ</Button>
      <Button active={language === 'en'} onClick={() => setLanguage('en')} data-active={language === 'en'}>EN</Button>
    </Switcher>
  );
};

export default LanguageSwitcher;
